.slice {
	align-content: center;
	clip-path: polygon(0% 0, 100% 50%, 0% 100%);
	display: grid;
	font-size: 1.25rem;
	grid-area: 1 / -1;
	list-style: none;
	padding-left: 0;
	transform-origin: center right;
	width: 50cqi;

	.sliceContent {
		padding: 1em;
	}
}
